import CotacaoFrete from '@/frete/cotacao/CotacaoFrete.vue';
import CadastroCotacaoFrete from '@/frete/cotacao/cadastro/CadastroCotacaoFrete.vue';
import CotacaoFreteDetalhes from '@/frete/cotacao/detalhes/CotacaoFreteDetalhes.vue';
import RespostaCotacaoFreteDetalhes
  from '@/frete/cotacao/detalhes/respostas/detalhes/RespostaCotacaoFreteDetalhes.vue';
import Contratacao from '@/frete/cotacao/contratacao/Contratacao.vue';
import ContratacaoListagem from '@/frete/cotacao/contratacao/lista/ContratacaoListagem.vue';
import ContratacaoDetalhes from '@/frete/cotacao/contratacao/detalhes/ContratacaoDetalhes.vue';
import CotacaoFreteEdicao from '@/frete/cotacao/edicao/CotacaoFreteEdicao.vue';
import DashboardFrete from '@/frete/dashboard/DashboardFrete.vue';

export default [
  {
    path: 'cotacoes-fretes',
    name: 'main.gestao-frete.cotacoes',
    components: {
      default: CotacaoFrete,
    },
  },
  {
    path: 'cadastro-cotacao-frete',
    name: 'main.gestao-frete.cadastro-cotacao',
    components: {
      default: CadastroCotacaoFrete,
    },
  },
  {
    path: 'edicao-cotacao-frete/:id',
    name: 'main.gestao-frete.edicao-cotacao',
    components: {
      default: CotacaoFreteEdicao,
    },
  },
  {
    path: 'cotacoes-fretes/:id',
    name: 'main.gestao-frete.cotacoes.detalhes',
    components: {
      default: CotacaoFreteDetalhes,
    },
  },
  {
    path: 'cotacoes-fretes/:id/respostas/:idResposta',
    name: 'main.gestao-frete.cotacoes.detalhes.resposta',
    components: {
      default: RespostaCotacaoFreteDetalhes,
    },
  },
  {
    path: 'cotacoes-fretes/:id/respostas/:idResposta/contratar',
    name: 'main.gestao-frete.cotacoes.detalhes.resposta.contratacao',
    components: {
      default: Contratacao,
    },
  },
  {
    path: 'contratacoes-fretes',
    name: 'main.gestao-frete.contratacoes',
    components: {
      default: ContratacaoListagem,
    },
  },
  {
    path: 'contratacoes-fretes/:id',
    name: 'main.gestao-frete.contratacoes.detalhes',
    components: {
      default: ContratacaoDetalhes,
    },
  },
  {
    path: 'dashboard-frete',
    name: 'main.gestao-frete.dashboard',
    components: {
      default: DashboardFrete,
    },
  },
];
